import { SeuConfigInputItem } from '@seu-types';
import { SeuApiOperatingCondition, SeuApiSaveOperatingCondition } from '../api';

export type SeuOperatingConditionInputStream = {
  inputStreamId?: string;
  inputs: SeuConfigInputItem[];
  version: number;
};

export const SEU_OPERATING_CONDITION_CATEGORIES = [
  'WARRANTY',
  'PART_LOAD',
  'MAXIMUM_LOAD',
  'NOMINAL',
  'OTHER',
] as const;

export type SeuOperatingConditionCategory =
  (typeof SEU_OPERATING_CONDITION_CATEGORIES)[number];

export type SeuOperatingConditionBase = {
  title: string;
  description?: string;
  categories?: SeuOperatingConditionCategory[];
  inputStreams: SeuOperatingConditionInputStream[];
  active: boolean;
};

export type SeuOperatingCondition = SeuOperatingConditionBase & {
  id: string;
};

export type SeuSaveOperatingConditionApi = SeuApiSaveOperatingCondition;

export type SeuOperatingConditionApi = SeuApiOperatingCondition;

export type SeuOperatingConditionUpdateRequest = SeuApiSaveOperatingCondition;
